module.exports = __webpack_public_path__ + "static/media/icon-teams-roles-unchecked.7dc464e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teams-roles-unchecked.svg
// module id = 1907
// module chunks = 0